// Exp required to advance FROM `level` to `level + 1`
export function expForLevel(level: number): number {
  return level * level * 100;
}

export interface ExpResult {
  level: number;
  exp: number;          // remaining progress within the (new) current level
  leveledUp: boolean;
  levelsGained: number;
}

// Apply an exp gain, rolling over into level-ups as needed.
export function applyExp(level: number, exp: number, gain: number): ExpResult {
  let lv = level;
  let e  = exp + Math.max(0, Math.floor(gain));
  let gained = 0;

  while (e >= expForLevel(lv)) {
    e -= expForLevel(lv);
    lv += 1;
    gained += 1;
  }

  return { level: lv, exp: e, leveledUp: gained > 0, levelsGained: gained };
}

// Player max HP scales with level
export function maxHpForLevel(level: number): number {
  return level * 100;
}

// Player attack scales with level
export function attackForLevel(level: number): number {
  return level * 10;
}

// Player defense scales with level — flat mitigation against monster counters
export function defenseForLevel(level: number): number {
  return level * 2;
}
